import { getPathFromCognitoState } from "@/features/sso-proxy/sso-proxy-utils";

/**
 * Handles auth redirect after Cognito authentication.
 * Uses router guard to intercept initial navigation and redirect to original path.
 *
 * @see features/auth/AUTH_FLOW.md
 */
export default defineNuxtPlugin(() => {
  const { code, state } = getAuthParams();
  if (!code || !state) return;

  const redirectPath = parseRedirectPath(state);
  if (!redirectPath) return;

  const router = useRouter();
  const unregister = router.beforeEach((to) => {
    unregister();
    if (to.path === "/") {
      return redirectPath;
    }
  });
});

function getAuthParams() {
  // we need to use the window.location.href because `useRoute()` won't work with hash routing
  const url = new URL(window.location.href).searchParams;
  return { code: url.get("code"), state: url.get("state") };
}

function parseRedirectPath(state: string): string | null {
  try {
    return getPathFromCognitoState(state);
  } catch (error) {
    console.error("[AUTH_REDIRECT] Error decoding redirect path", error);
    return null;
  }
}
